<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Ações de extensão com mais de 6 meses em preenchimento incompleto'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="listaProjetos"
              :search="search"
              :no-data-text="'Nenhuma ação com mais de 6 meses em preenchimento incompleto'"
              must-sort
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :items-per-page="itemsPerPage"
              :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.titulo="props">
                <router-link :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{props.item.titulo}}</router-link>
              </template>
              <template v-slot:item.opcoes="props">
                <v-btn color="primary" text icon @click="excluirAcao(props.item.idProjeto)" >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} ações
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      listaProjetos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      excluirAcao: function (idProjeto) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        projetos.deleteProjeto(idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          for (let i = 0; i < this.listaProjetos.length; i++) {
            if (this.listaProjetos[i].idProjeto === idProjeto) {
              this.listaProjetos.splice(i, 1)
              i--
            }
          }
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
      projetos.getProjetosVencidos()
      .then(response => {
        this.listaProjetos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.listaProjetos = []
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>



// WEBPACK FOOTER //
// projetos-vencidos-tabela.vue?da8f8268